import React from 'react';
import T from 'prop-types';
import './styles.scss';

const RADIUS = 54;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const progress = (value) => {
  const progress = value / 100;
  const dashoffset = CIRCUMFERENCE * (1 - progress);
  return dashoffset;
};

/**
 *  Will output a radial circle progress meter in SVG
 *
 */
const Progressbar = (props) => {
  return (
    <div className="progressbar">
      <div className="progress__text">{props.percent}%</div>
      <svg
        aria-labelledby="title"
        className="progress"
        width={props.size}
        height={props.size}
        viewBox="0 0 120 120"
      >
        <title id="title">{props.percent} %</title>
        <circle
          className="progress__meter"
          cx="60"
          cy="60"
          r="54"
          strokeWidth={props.strokeWidth}
        />
        <circle
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={progress(props.percent)}
          className="progress__value"
          cx="60"
          cy="60"
          r="54"
          strokeWidth={props.strokeWidth}
        />
      </svg>
    </div>
  );
};

Progressbar.propTypes = {
  /** How much progress */
  percent: T.number,
  /** Width and Height of <SVG> element */
  size: T.number,
  /** Width of meter and value stroke. */
  strokeWidth: T.number,
};

export default Progressbar;
